module.exports = __webpack_public_path__ + "static/img/trainingDuration.9fb0b294.svg";